import { getOfficialAccountAppId } from './official-account'

// 获取code方法 在js中不建议使用route.query.code方式

/**
     * 获取路径参数code
     */
const getUrlCodeParam = (name) => {
  const match = new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href)
  return match ? decodeURIComponent(match[1].replace(/\+/g, '%20')) : null
}
export const getLoginCode = (parkId) => {
  const ua = navigator.userAgent.toLowerCase()
  // 判断是否在微信内部调用 ：/micromessenger/.test(ua)
  if (!/micromessenger/.test(ua)) {
    console.error('不在微信环境内')
    return
  }

  // 这里是通过getUrlCodeParam('code')方法处理ulr中的 code
  const code = getUrlCodeParam('code')
  if (code) {
    console.log('返回的code数据')
    console.log(code)
    return code
  }

  const redirectUrl = encodeURIComponent(window.location.href)
  const appId = getOfficialAccountAppId(parkId)
  const url =
    'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
    appId +
    '&redirect_uri=' +
    redirectUrl +
    '&response_type=code&scope=snsapi_base&state=1#wechat_redirect'
  window.location.href = url
}
